import { SubmitUserSentimentFeedbackRequest } from '@sparx/api/apis/sparx/reading/feedback/v1/feedback';
import { useMutation } from '@tanstack/react-query';
import { feedbackClient } from 'api';

export const useSubmitSentimentFeedback = () =>
  useMutation(
    (input: SubmitUserSentimentFeedbackRequest) =>
      feedbackClient.submitUserSentimentFeedback(input).response,
  );
